import { Button } from "@components";
import { LogicalOperandTexts } from "@core/oraculo";
import classNames from "classnames/bind";
import React from "react";
import { Clause } from "./Clause";

import { ForEach, If } from "@components/control-statements";
import { VariableSchema } from "@containers/oraculo/VariableSchema";
import style from "@styles/pages/cdp/cdp-base-node.module.scss";

const css = classNames.bind(style);

const LogicalConnector = ({ operand, onClick }) => (
  <div className={css({ logicalOperator: true, disabled: false })}>
    <span>{LogicalOperandTexts[operand || "and"]}</span>
  </div>
);

export const Scope = ({ scope, valueType, onClick, className }) => {
  const filtered_items =
    scope.items.filter((i) => VariableSchema.countValidClauses(i) > 0) || [];

  const toggle = (e) => {
    return onClick(e, {
      action: "apply",
      target: scope.id,
      data: { operand: scope.operand == "or" ? "and" : "or" },
    });
  };

  return (
    <div className={className}>
      <ForEach
        items={filtered_items}
        render={(item, index) => {
          return (
            <>
              <If cond={item.type == "scope"}>
                <Scope scope={item} valueType={valueType} onClick={onClick} />
              </If>
              <If cond={item.type != "scope" && !item.hide}>
                <Clause clause={item} valueType={valueType} onClick={onClick} />
              </If>
              <If cond={index < filtered_items.length - 1}>
                <LogicalConnector operand={scope.operand} onClick={toggle} />
              </If>
            </>
          );
        }}
      />
    </div>
  );
};
